/** CRO test taxonomy labels — mirrors backend reportTaxonomy.js */

export const PAGE_TYPES = [
  { value: 'homepage', label: 'Anasayfa' },
  { value: 'plp', label: 'Liste (PLP)' },
  { value: 'pdp', label: 'Ürün Detay (PDP)' },
  { value: 'cart', label: 'Sepet' },
  { value: 'checkout', label: 'Checkout' },
  { value: 'landing', label: 'Landing Page' },
  { value: 'other', label: 'Diğer' },
];

export const CHANGE_TYPES = [
  { value: 'copy', label: 'Metin / Copy' },
  { value: 'layout', label: 'Layout / Düzen' },
  { value: 'cta', label: 'CTA / Buton' },
  { value: 'pricing', label: 'Fiyatlandırma' },
  { value: 'form', label: 'Form' },
  { value: 'navigation', label: 'Navigasyon' },
  { value: 'trust', label: 'Güven / Sosyal Kanıt' },
  { value: 'other', label: 'Diğer' },
];

export const SUGGESTED_TAGS = [
  'checkout',
  'cta',
  'copy',
  'pricing',
  'navigation',
  'form',
  'hero',
  'mobile',
  'plp',
  'homepage',
  'trust',
  'urgency',
];

export const RESULT_FILTERS = [
  { value: '', label: 'Tüm sonuçlar' },
  { value: 'Kazandı', label: 'Kazandı' },
  { value: 'Kaybetti', label: 'Kaybetti' },
  { value: 'Etkisiz', label: 'Etkisiz' },
];

export const getPageTypeLabel = (value) =>
  PAGE_TYPES.find((p) => p.value === value)?.label || value || '—';

export const getChangeTypeLabel = (value) =>
  CHANGE_TYPES.find((c) => c.value === value)?.label || value || '—';

export const getOutcomeChip = (resultStatuses = []) => {
  if (resultStatuses.includes('Kazandı')) return { label: 'Kazandı', color: 'success' };
  if (resultStatuses.includes('Kaybetti')) return { label: 'Kaybetti', color: 'error' };
  if (resultStatuses.includes('Etkisiz')) return { label: 'Etkisiz', color: 'default' };
  return { label: 'Belirsiz', color: 'default' };
};
